export default __webpack_public_path__ + "static/media/cert-general2024-hkgcsmeaa-sc.75b86378.jpg";